import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=189f83cc&scoped=true"
import script from "./ModelForm.vue?vue&type=script&lang=js"
export * from "./ModelForm.vue?vue&type=script&lang=js"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=189f83cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f83cc",
  null
  
)

export default component.exports